module.exports = __webpack_public_path__ + "img/shadows.638756b2.jpeg";